export const environment = {
  production: true,
  apiURL: "aHR0cHM6Ly9wcm9kLWRyZWFtc29sdXRpb25zLXBvcy1hdXRoLmF6dXJld2Vic2l0ZXMubmV0L2FwaS92MS8=",
  ambiente: 'Prod - ',
  domain: "https://prod-dreamsolutions-pos-front.azurewebsites.net/",
  encryptionType: 'AES-ENC',
  aesKey: 'NjhEQ0U1RkVFQzcwMUY5ODYxOUYxQURDRDE0NzE5Njg=',
  transformActive: true,
  // Configuración de WebSocket
  websocket: {
    enabled: true, // Habilitado para producción (plantilla configurable)
    host: 'prod-dreamsolutions-pos-front.azurewebsites.net',
    port: '443', // Puerto HTTPS estándar
    protocol: 'wss' // WSS para HTTPS
  }
};

